var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lock-path",
    fill: "#6173fe",
    id: "60u9dvrv3a",
    d: "M18.545 11.182H16.91V7.909C16.91 5.198 14.711 3 12 3S7.09 5.198 7.09 7.91v3.272H5.456C4.098 11.182 3 12.28 3 13.636v4.91C3 19.901 4.098 21 5.455 21h13.09C19.902 21 21 19.902 21 18.545v-4.909c0-1.356-1.098-2.454-2.455-2.454zM8.727 7.909c0-1.807 1.466-3.273 3.273-3.273 1.807 0 3.273 1.466 3.273 3.273v3.273H8.727V7.909zm10.637 10.636c0 .452-.367.819-.819.819H5.455c-.452 0-.819-.367-.819-.819v-4.909c0-.452.367-.818.819-.818h13.09c.452 0 .819.366.819.818v4.91z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-336 -615) translate(48 279) translate(0 336) translate(288)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H24V24H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.2e1e3b62.svg";
export { ForwardRef as ReactComponent };